<template>
  <div class="content">
    <div class="inner_content">
      <div class="header">
        <div class="box flex" style="align-items:center">
          <div class="title">领取方式：</div>
          <el-select
            v-model="get_type"
            placeholder="请选择"
            size="small"
            class="fixedwidth"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button type="primary" size="small" @click="getLists"
            >筛选</el-button
          >
        </div>
      </div>
      <div class="bottom">
        <el-table
          v-loading="loading"
          :data="tableData"
          size="small"
          :header-cell-style="setHeader"
          height="100%"
        >
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="title" label="券名称"></el-table-column>
          <el-table-column label="券类型">
            <template slot-scope="scope">
              <div v-if="scope.row.coupon_type == 1">满减券</div>
              <!-- <div v-if="scope.row.coupon_type == 2">折扣券</div> -->
              <div v-if="scope.row.coupon_type == 3">代金券</div>
              <div v-if="scope.row.coupon_type == 4">兑换券</div>
              <div v-if="scope.row.coupon_type == 5">储值券</div>
              <div v-if="scope.row.coupon_type == 6">通用券</div>
              <div v-if="scope.row.coupon_type == 7">次数券</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="" label="消费产品"></el-table-column>
          <el-table-column prop="" label="消费金额"></el-table-column> -->
          <el-table-column prop="info.id" label="会员ID"></el-table-column>
          <el-table-column
            prop="info.real_name"
            label="会员名"
          ></el-table-column>
          <el-table-column prop="info.mobile" label="电话"></el-table-column>
          <el-table-column label="操作人" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.is_cancle == 0">
                <el-button type="text">用户本人</el-button>
              </div>
              <div v-if="scope.row.is_cancle == 1">
                <el-button type="text">{{ scope.row.employee.name }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next, jumper"
          :total="total_num"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { couponVerifiy } from "@/api/coupon";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      loading: false,
      is_used: "1", //使用状态
      is_cancle: "", //核销状态 0 用户使用 1 扫码核销
      get_type: "1", //领取方式
      page: "1",
      total_num: 0,
      tableData: [],
      formLabelWidth: "120px",
      dialogFormVisible: false,
      options: [
        {
          value: "0",
          label: "用户使用"
        },
        {
          value: "1",
          label: "扫码核销"
        }
      ],
      typeOptions: [
        {
          value: "0",
          label: "平台发放"
        },
        {
          value: "1",
          label: "用户领取"
        }
      ],
      value1: "",
      value: "",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      }
    };
  },
  mounted() {
    this.getLists();
  },
  methods: {
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    addSlice() {
      this.$router.push({
        path: `adSign`
      });
    },
    // 核销记录
    getLists() {
      this.loading = true;
      let data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        get_type: this.get_type
      };
      couponVerifiy(data).then(res => {
        console.log("sss", res);
        this.loading = false;
        if (res.code == 200) {
          this.tableData = res.data.result;
          this.total_num = res.data.total_num;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getLists();
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 26px 11px 20px;
  overflow: auto;
  min-width: 900px;
  border: node;
  // background: rgba(240, 242, 245, 1);
  .inner_content {
    background: #fff;
    padding: 0 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .header {
      padding-top: 20px;
      margin-bottom: 20px;
      .box {
        width: 330px;
        .title {
          min-width: 100px;
          text-align: right;
        }
        .fixedwidth {
          width: 180px;
          display: flex;
          justify-content: space-between;
        }
      }
    }
    .bottom {
      flex: 1;
      overflow-y: scroll;
    }
    .page {
      height: 50px;
      display: flex;
      align-items: center;
    }
  }
}
// 通用样式
.flex {
  display: flex;
  align-items: center;
  padding: 10px 0px;
}
.el-table td {
  // padding: 12px 0;
}
</style>
